export default __webpack_public_path__ + "static/media/ic_Growth_48px.fce02ebc.svg";